import React from 'react';
import { Link } from 'react-router-dom';
import './Home.css';
import LiveTicker from '../components/LiveTicker';
import LivePrices from '../components/LivePrices';



const STATS = [
  { value: '4+', label: 'Years Combined Experience', icon: '📈' },
  { value: '500+', label: 'Students Trained', icon: '🎓' },
  { value: '95%', label: 'Accuracy Rate', icon: '🎯' },
  { value: '₹1Cr+', label: 'Student Profit Generated', icon: '💰' },
];

const FEATURES = [
  { icon: '📊', title: 'Technical Analysis', desc: 'Master chart patterns, indicators, and price action strategies used by professionals.' },
  { icon: '💹', title: 'Live Trading Calls', desc: 'Get real-time buy/sell signals for Crypto and Indian stock markets.' },
  { icon: '🧠', title: 'Psychology & Mindset', desc: 'Learn stress management and emotional discipline to trade like a pro.' },
  { icon: '💰', title: 'Capital Management', desc: 'Risk management strategies to protect and grow your portfolio consistently.' },
  { icon: '🪙', title: 'Crypto Markets', desc: '2+ years of deep crypto experience — spot, futures, DeFi, and Web3 investing.' },
  { icon: '🇮🇳', title: 'Indian Stock Market', desc: '3+ years of NSE/BSE expertise — equities, F&O, and swing trading strategies.' },
];

const TESTIMONIALS = [
  { name: 'Rahul Sharma', city: 'Noida', text: 'Kalpnic Trading changed my approach to trading. Made ₹1.2L profit in just 2 months using their price action strategies.', rating: 5 },
  { name: 'Priya Mehta', city: 'Delhi', text: 'The crypto course was mind-blowing. Finally understand market cycles and how to time entries and exits.', rating: 5 },
  { name: 'Arjun Singh', city: 'Greater Noida', text: 'Their live signals are incredibly accurate. Subscribed to the 6-month plan and already made my investment back.', rating: 5 },
];

const Home = () => {
  const WHATSAPP_NUMBER = '919926749937';
  const message = encodeURIComponent('Hi Kalpnic Trading! I want to join your trading course.');

  return (
    <div className="home">
      {/* Ticker */}
      <LiveTicker />

      {/* Hero */}
      <section className="hero section-padding grid-bg">
        <div className="hero-glow" />
        <div className="container hero-container">
          <div className="hero-content">
            <div className="tag">🇮🇳 India's Premier Trading Academy</div>
            <h1 className="hero-title section-title">
              Master the Art of<br />
              <span className="gold-text">Trading & Investing</span>
            </h1>
            <p className="hero-subtitle section-subtitle">
              Learn from a trader with 4+ years of experience across Crypto and Indian markets. 
              From technical analysis to live signals — we guide you every step of the way.
            </p>
            <div className="hero-badges">
              <span className="badge">✅ Crypto Expert</span>
              <span className="badge">✅ NSE/BSE Specialist</span>
              <span className="badge">✅ Price Action Pro</span>
            </div>
            <div className="hero-cta">
              <a href={`https://wa.me/${WHATSAPP_NUMBER}?text=${message}`} target="_blank" rel="noreferrer" className="btn-gold">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
                </svg>
                Join on WhatsApp
              </a>
              <Link to="/courses" className="btn-outline">View Courses</Link>
            </div>
          </div>
          <div className="hero-chart-card">
            <div className="chart-header">
              <span className="chart-title">Portfolio Performance</span>
              <span className="chart-badge up">▲ Live</span>
            </div>
            <div className="chart-display">
              <svg viewBox="0 0 300 120" className="chart-svg">
                <defs>
                  <linearGradient id="chartGrad" x1="0" y1="0" x2="0" y2="1">
                    <stop offset="0%" stopColor="#f0b429" stopOpacity="0.4"/>
                    <stop offset="100%" stopColor="#f0b429" stopOpacity="0"/>
                  </linearGradient>
                </defs>
                <path d="M0,100 L30,85 L60,90 L90,70 L120,60 L150,65 L180,45 L210,30 L240,35 L270,15 L300,10 L300,120 L0,120Z" fill="url(#chartGrad)" />
                <path d="M0,100 L30,85 L60,90 L90,70 L120,60 L150,65 L180,45 L210,30 L240,35 L270,15 L300,10" fill="none" stroke="#f0b429" strokeWidth="2" />
                <circle cx="300" cy="10" r="4" fill="#f0b429" />
              </svg>
            </div>
            <div className="chart-stats">
              <div className="cs-item">
                <span className="cs-label">Total Returns</span>
                <span className="cs-val up">+142.8%</span>
              </div>
              <div className="cs-item">
                <span className="cs-label">Signals This Month</span>
                <span className="cs-val">48</span>
              </div>
              <div className="cs-item">
                <span className="cs-label">Win Rate</span>
                <span className="cs-val up">90%</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Stats */}
      <section className="stats-section">
        <div className="glow-line" />
        <div className="container">
          <div className="stats-grid">
            {STATS.map((s, i) => (
              <div className="stat-card" key={i} style={{ animationDelay: `${i * 0.1}s` }}>
                <span className="stat-icon">{s.icon}</span>
                <span className="stat-value gold-text">{s.value}</span>
                <span className="stat-label">{s.label}</span>
              </div>
            ))}
          </div>
        </div>
        <div className="glow-line" />
      </section>

      <LivePrices />

      {/* Features */}
      <section className="features section-padding">
        <div className="container">
          <div className="section-header">
            <div className="tag">What We Offer</div>
            <h2 className="section-title">Everything You Need to<br /><span className="gold-text">Trade Successfully</span></h2>
            <p className="section-subtitle">Comprehensive training and live support across all major markets.</p>
          </div>
          <div className="features-grid">
            {FEATURES.map((f, i) => (
              <div className="feature-card card" key={i} style={{ animationDelay: `${i * 0.1}s` }}>
                <span className="feature-icon">{f.icon}</span>
                <h3>{f.title}</h3>
                <p>{f.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Banner */}
      <section className="cta-banner">
        <div className="cta-glow" />
        <div className="container">
          <div className="cta-content">
            <h2 className="section-title">Ready to Start Your<br /><span className="gold-text">Trading Journey?</span></h2>
            <p>Join hundreds of successful traders. Get live calls, expert mentoring, and a community that grows together.</p>
            <div className="cta-buttons">
              <Link to="/subscription" className="btn-gold">View Subscription Plans</Link>
              <a href={`https://wa.me/${WHATSAPP_NUMBER}?text=${message}`} target="_blank" rel="noreferrer" className="btn-outline">Chat with Us</a>
            </div>
          </div>
        </div>
      </section>

      {/* Testimonials */}
      <section className="testimonials section-padding">
        <div className="container">
          <div className="section-header">
            <div className="tag">Student Success</div>
            <h2 className="section-title">What Our Traders <span className="gold-text">Say</span></h2>
          </div>
          <div className="testimonials-grid">
            {TESTIMONIALS.map((t, i) => (
              <div className="testimonial-card card" key={i}>
                <div className="stars">{'⭐'.repeat(t.rating)}</div>
                <p className="testimonial-text">"{t.text}"</p>
                <div className="testimonial-author">
                  <div className="author-avatar">{t.name[0]}</div>
                  <div>
                    <div className="author-name">{t.name}</div>
                    <div className="author-city">📍 {t.city}</div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;
